export const NETWORK_LOWER_THRESHOLD = 150 // kpbs

export const NETWORK_SPEED_KBPS = 'NETWORK_SPEED_KBPS'

const asset = {
    url:
        'https://res.cloudinary.com/openhouse-study/image/upload/v1623921111/network-test-img-compressed.jpg',
    size: 182910, // bytes
}

export const networkSpeedStore = {
    get: () => sessionStorage.getItem(NETWORK_SPEED_KBPS),
    set: (speed = 0) => sessionStorage.setItem(NETWORK_SPEED_KBPS, speed),
    del: () => sessionStorage.removeItem(NETWORK_SPEED_KBPS),
}

export const checkDownloadSpeed = async () => {
    const downloadImage = () => {
        return new Promise((resolve, reject) => {
            let startTime, endTime

            const img = new Image()

            img.onload = () => {
                // image  has been loaded
                endTime = new Date().getTime()
                const result = calculate(startTime, endTime, asset.size)
                console.table(result)
                resolve(result)
            }

            img.onerror = () => {
                // image  failed to download
                const error = 'Error Downloading Image'
                console.error(error)
                reject(error)
            }

            startTime = new Date().getTime()
            img.src = `${asset.url}?time=${startTime}`
        })
    }

    const numberOfDownloads = 1

    const results = []

    // here we don't have to run promises in parallel, so avoid promise.all
    for (let i = 0; i < numberOfDownloads; i++) {
        results.push(await downloadImage())
    }

    const totalSpeedInKbps = results.reduce(
        (accumulator, currentItem) => accumulator + currentItem.speedKbps,
        0
    )

    const averageSpeedInKbps = Math.round(totalSpeedInKbps / numberOfDownloads)

    console.log(`averageSpeedInKbps :- `, averageSpeedInKbps)

    return averageSpeedInKbps
}

const calculate = (start, end, size) => {
    const duration = (end - start) / 1000
    const bitsLoaded = size * 8
    const speedBps = parseFloat((bitsLoaded / duration).toFixed(2))
    const speedKbps = parseFloat((speedBps / 1024).toFixed(2))
    const speedMbps = parseFloat((speedKbps / 1024).toFixed(2))

    return {
        duration,
        bitsLoaded,
        speedBps,
        speedKbps,
        speedMbps,
    }
}
